import { Link } from "react-router-dom";

export default function Event () {
    return (
        <>
        <div className="bg-[#57562A] md:max-w-[800px] lg:max-w-[1100px] rounded mx-auto text-white pb-5">
<div className="md:flex h-auto items-center justify-center hidden md:block pt-5 ">

    <div className="md:w-1/2 m-5 flex flex-col lg:justify-end">
        <div className="md:text-end mb-10">
            <p className="text-[#E9A3FF]">NEXT EVENT</p>
            <h1 className="text-xl md:text-xl mb-2">RHYTHM & FLOW</h1>
            <p className="mb-5 ">🌞 Join us August 30 for a day of movement, music & fun along Mission Bay at Fiesta Island! 🌊

​We’ll begin at 11 AM with a yoga + fitness flow, with DJ sets throughout the day. Come for the workout or after, and feel free to arrive whenever you’d like! ✨


            </p>
            <p className="font-bold">📍 FIESTA ISLAND</p>
            <p className="mb-5 font-bold">Sunday, August 30th, 11AM-afternoon</p>
            <button
        className="text-[#57562A] bg-[#E9A3FF] hover:bg-[#ECB0FF]  rounded-full px-4 py-2"
      >
        <Link to="https://luma.com/fsaj9rdl">Sign Up Here</Link>

      </button>
            {/* <button>
                <Link
                    to="https://www.eventbrite.com/e/morning-vinyasa-flow-in-balboa-park-nature-flow-tickets-1375070566079?aff=oddtdtcreator"
                    className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
                >
                    Sign Up Here
                </Link>
            </button> */}
        </div>
        {/* <div className="md:text-end p-4 border">
            <h1 className="text-4xl md:text-2xl mb-2">Vinyasa Flow at Mind Body Love</h1>
            <p className="mb-5 ">Flow with me into the morning Tuesdays and Sundays at Mind Body Love
            </p>
            <button>
                <Link
                    to="https://www.eventbrite.com/e/morning-vinyasa-flow-in-balboa-park-nature-flow-tickets-1375070566079?aff=oddtdtcreator"
                    className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
                >
                    See Schedule
                </Link>
            </button>
        </div> */}
    </div>

    <div className="md:w-2/3 m-5 flex justify-center">
        <img
            src={require("./images/ebbflowflyer.PNG")}
            alt="Yoga Art Event San Diego"
            className="md:w-full lg:w-2/3 object-cover h-[500px] max-w-[400px]"
        />
    </div>
</div>

<div className="items-center justify-center pt-5 md:hidden">
    <div className="md:w-2/3 m-5 flex justify-center">
        <img
            src={require("./images/ebbflowflyer.PNG")}
            alt="Yoga Art Event San Diego"
            className="md:w-full lg:w-2/3 object-cover h-[500px]"
        />
    </div>
        <div className=" m-5 flex flex-col">
        <div className=" mb-10">
            <p className="text-[#E9A3FF]">NEXT EVENT</p>
            <h1 className="text-2xl mb-2 ">RHYTHM & FLOW</h1>
            <p className="mb-5 ">🌞 Join us August 30 for a day of movement, music & fun along Mission Bay at Fiesta Island! 🌊

​We’ll begin at 11 AM with a yoga + fitness flow, with DJ sets throughout the day. Come for the workout or after, and feel free to arrive whenever you’d like! ✨


            </p>
            <p className="font-bold">📍 FIESTA ISLAND</p>
            <p className="mb-5 font-bold">Sunday, August 30th, 11AM-afternoon</p>
            <button
        className="text-white bg-[#E9A3FF] hover:bg-purple-700 rounded-full px-4 py-2"
      >
        <Link to="https://luma.com/fsaj9rdl">Sign Up Here</Link>

      </button>
        </div>
    </div>

    {/* <div className=" m-5 flex flex-col">
        <div className=" mb-10">
            <p className="">NEXT EVENT</p>
            <h1 className="text-2xl mb-2 ">ROOFTOP YOGA & MIMOSAS</h1>
            <p className="mb-5 ">Start your Saturday with rooftop views, a guided yoga flow, and a post-class mimosa at Margaritaville Hotel San Diego.
                Join us on Saturday, May 16, from 9:30 – 10:30 AM for a Rooftop Yoga & Mimosas* experience at Margaritaville Hotel San Diego. Led by local yogi Sina Klughardt, this all-levels vinyasa flow is designed to energize your body and reset your mind—all set against scenic rooftop views in an open-air setting.
After class, keep the good vibes going with a complimentary mimosa.
            </p>
            <p className="font-bold">📍 Margaritaville Hotel San Diego, Gaslamp Quarter</p>
            <p className="mb-5 font-bold">Saturday, May 16, 9:30am</p>
            <button
        className="text-white bg-[#E9A3FF] hover:bg-purple-700 rounded-full px-4 py-2"
      >
        <Link to="https://www.eventbrite.com/e/rooftop-yoga-mimosas-tickets-1988412792188?aff=oddtdtcreator&keep_tld=true&utm_campaign=yoga&utm_source=meta&utm_medium=social">Sign Up Here</Link>

      </button>
        </div>
    </div> */}

    {/* <div className=" m-5 flex flex-col">
        <div className=" mb-10">
            <p className="text-[#E9A3FF]">NEXT EVENT</p>
            <h1 className="text-2xl mb-2 ">MOVE & MELT - VINYASA & SOUND</h1>
            <p className="mb-5 ">This 90-minute event begins with 60 minutes of vinyasa flow with Sina: breath-led, heat-building, designed to move energy and release what’s stuck. Then settle into 30 minutes of sound healing with Kim, as sounds wash over you and guide you into deep restoration.
            </p>
            <p className="font-bold">📍 MIND BODY LOVE, 30th st, South Park, San Diego</p>
            <p className="mb-5 font-bold">Saturday, June 25, 3PM</p>
            <button
        className="text-white bg-[#E9A3FF] hover:bg-purple-700 rounded-full px-4 py-2"
      >
        <Link to="https://app.arketa.co/mindbodylove/checkout/guWHQLFjQFvsT4mERBAR">Sign Up Here</Link>

      </button>
        </div>
    </div> */}

</div>

</div>

        </>
    )
}
